import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent {

  resetPasswordForm!: FormGroup;
  oldPasswordErrorMessage: string;

  constructor(private fb: FormBuilder,
    private authservice: AuthenticationService,
    private router: Router,
    private messageService: MessageService) { }

  ngOnInit(): void {
    this.resetPasswordForm = this.fb.group({
      newPassword: ['', Validators.required],
      confirmPassword: ['', Validators.required],
      oldPassword: ['', Validators.required]
    }, { validators: this.passwordMatchValidator });

    this.resetPasswordForm.get('oldPassword')?.valueChanges.subscribe(() => {
      this.oldPasswordErrorMessage = '';
    });
  }

  passwordMatchValidator(form: AbstractControl): null | object {
    const password = form.get('newPassword')?.value;
    const confirmPassword = form.get('confirmPassword')?.value;
    if (password && confirmPassword && password !== confirmPassword) {
      form.get('confirmPassword')?.setErrors({ mismatch: true });
      return { mismatch: true };
    }
    return null;
  }

  onSubmit(): void {
    if (this.resetPasswordForm.valid) {
      console.log('Form Submitted', this.resetPasswordForm.value);
      // Perform the password reset logic here
      const userEmail = sessionStorage.getItem('loginUserName');
      const password = { email: userEmail, oldPassword: this.resetPasswordForm.value.oldPassword, newPassword: this.resetPasswordForm.value.newPassword, };
      this.authservice.updateUserPassword(password).subscribe(
        response => {
          console.log('Password reset successfully', response);

          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Password has been reset successfully!'
          });

          this.router.navigate(['/boards']);
        },
        error => {

          if (error.status === 400) {

            this.oldPasswordErrorMessage = 'Old password is incorrect.';
            // this.messageService.add({
            //   severity: 'error',
            //   summary: 'Error',
            //   detail: 'Old password is incorrect. Please try again.'
            // });

          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Failed to reset password. Please try again.'
            });
          }


        }
      );

    }
  }

}
